import React from "react"

import { twMerge } from "tailwind-merge"
import { capitalize } from "underscore.string"

import { Icon } from "~/src/components/Icon"
import { SelectableType } from "~/src/types/productSelection"

export type StockIndicatorProps = {
  quantity?: number
  /**
   * @deprecated Set `quantity` to `Infinity` to indicate that stock is not required instead.
   */
  required?: boolean
  /**
   * @deprecated Use `forKit` instead.
   */
  type?: SelectableType
  className?: string
  hideDot?: boolean
  forKit?: boolean
}

/**
 * Renders a standard BeeKit stock indicator.
 * @param props
 * @param props.className classes passed through to top-level div.
 * @param props.forKit whether or not this is for kit which displays as "available" instead of "in stock" (default: false)
 * @param props.hideDot whether or not to hide the dot (default: false)
 * @param props.quantity quantity of items in stock
 * @returns
 */
export function StockIndicator(props: StockIndicatorProps) {
  const { quantity = 0, className, required = true, hideDot = false, type = SelectableType.StoreProduct } = props
  const forKit = props.forKit ?? type === SelectableType.StoreKit
  const hideCount = quantity === Infinity || required === false

  const text = () =>
    capitalize([hideCount ? null : quantity, forKit ? "available" : "in stock"].filter((x) => x != null).join(" "))

  const dotColor = () => {
    switch (true) {
      case quantity >= 20 || hideCount:
        return "text-green-500"
      case quantity > 0:
        return "text-amber-500"
      default:
        return "text-red-600"
    }
  }

  return (
    <div className={twMerge("flex items-center gap-2", className)}>
      {hideDot || <Icon.Dot className={dotColor()} />}
      <span className="whitespace-nowrap text-sm">{text()}</span>
    </div>
  )
}
